import { Container } from "react-bootstrap";
import { Outlet } from "react-router";
import { ProfileProvider } from "../../Auth/ProfileProvider";
import NavMenu from "./NavMenu";

export default function Layout() {
  return (
    <ProfileProvider>
      <NavMenu />
      <Container fluid className="ps-5 pe-5 pt-2 pb-2">
        <Outlet></Outlet>
      </Container>
    </ProfileProvider>
  );
}
